module.exports = __webpack_public_path__ + "static/media/UC Compound Golf Still 01.RGB_color.0000.0bec1122.webp";